import i18n from '@/plugins/i18n';
import { Animations, ChartToolBar } from '../charts/charts.global.config';

export const metricColors = [
  '#3FB2C7',
  '#C73F9D',
  '#4AE875',
  '#4A8DE8',
  '#E84A7B',
  '#934AE8',
  '#E8D64A',
  '#F59600',
];

export const traceColors = [
  '#76CEEF',
  '#EF76C9',
  '#76EFA6',
  '#76AEEF',
  '#EF76A2',
  '#C576EF',
  '#EFEA76',
  '#FFB429',
];

export const dbColors = [
  '#B2E4FA',
  '#FAB2E3',
  '#B2FAC6',
  '#B2CFFA',
  '#FAB2D9',
  '#EFB2FA',
  '#F9FAB2',
  '#FFD97A',
];

export const logColors = [
  '#EFFDFF',
  '#FFEFFA',
  '#EFFFEF',
  '#EFF5FF',
  '#FFEFF5',
  '#FAEFFF',
  '#FFFDEF',
  '#FFF9E6',
];

export const capabilityMap = {
  A: i18n.global.t('usage.APM'),
  B: i18n.global.t('usage.browserMonitoring'),
  C: i18n.global.t('usage.googleKubernetesEngine'),
  S: i18n.global.t('usage.syntheticMonitoring'),
  D: i18n.global.t('usage.databaseMonitoring'),
  V: i18n.global.t('usage.vmMonitoring'),
  K: i18n.global.t('usage.kubernetesMonitoring'),
  M: i18n.global.t('usage.mobileMonitoring'),
};

export const setTotalSizeList = 'SET_TOTAL_SIZE_LIST ';
export const setTotalActiveAgents = 'SET_TOTAL_ACTIVE_AGENTS';

export const decimalRoundOff = 4;
export const getDataUnit = false;

export const billingCapabilityColor = {
  A: '#9E46F6',
  V: '#B46DF7',
  L: '#CB94F8',
  D: '#E0BCFA',
  NNU: '#F5F5F5',
  B: '#F59600',
  M: '#FFB429',
  S: '#EA3DC9',
  OU: '#F16755',
};

export const LEVELS = {
  DATASET: {
    key: 'Dataset',
    noDataKey: 'datasetNotInUse',
    overutilsedKey: 'overUtilizedDataset',
    unit: 'GB',
    title: 'Dataset Level',
    totalDatasetKey: 'totalDatasetCapacityBytes',
    totalDatasetUsedKey: 'totalDatasetUsedBytes',
  },
};

export const LICENSE_DISTRIBUTION_OPTIONS = {
  width: '48%',
  height: '12.5em',
  chart: {
    type: 'bar',
    animations: Animations,
    background: 'inherit',
    stacked: true,
    toolbar: ChartToolBar,
    stackType: '100%',
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '30%',
    },
  },
  dataLabels: {
    useHTML: true,
    enabled: false,
    style: {
      fontSize: '13px',
      fontWeight: 900,
    },
    offsetY: -5,
    formatter: (val, { seriesIndex, dataPointIndex, w }) => {
      const label = w.config.series[seriesIndex].labels[dataPointIndex];
      if (label) {
        const words = label.split(' ');
        if (words.length > 2) {
          return `${words[0]} ${words[1]}...`;
        } else {
          return words;
        }
      }
    },
  },
  title: {
    margin: 20,
    text: i18n.global.t('usage.monthlyLicenseDistribution'),
    style: {
      color: 'white',
      fontWeight: 'bold',
    },
  },
  grid: {
    show: false,
  },
  tooltip: {
    theme: 'dark',
    style: {
      background: '#333',
      color: '#fff',
    },
  },
  legend: {
    show: false,
  },
  xaxis: {
    show: false,
    categories: Object.keys(LEVELS).map((key) => LEVELS[key].title),
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      formatter: (value) => {
        return String(value).split('-');
      },
      style: {
        colors: ['#FFFFFF'],
        fontSize: '12px',
        fontWeight: 400,
      },
      offsetX: 2,
    },
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: false,
    },
  },
  colors: [
    '#9E46F6',
    '#B46DF7',
    '#CB94F8',
    '#E0BCFA',
    '#F59600',
    '#FFB429',
    '#EA3DC9',
    '#FFF9E6',
  ],
};

export const USAGE_GRAPH_COLOR_BY_LEVELS = {
  dataset: '#CB94F8',
  session: '#EE7BD3',
  endpoint: '#9FEEFD',
};
